import React, {memo, ReactNode, useCallback, useEffect, useState} from "react"
import {ControlModel, ControlTypeModel} from "../../../types/control"
import {useRPC} from "../../../hooks/rpc"
import {useDebounce} from "../../../hooks/debounce"
import {RgbColor} from "../../ColorPicker/types"
import "../../ColorPicker/index.scss"
import {Column} from "../../Column"
import {ColorPicker} from "../../ColorPicker"

type Props = {
    control: ControlModel
    controlType: ControlTypeModel
    children?: ReactNode
};

export const DimmerWithRGBControl = memo(function DimmerWithRGBControl(props: Props) {
    const {control, children, controlType} = props
    const [color, setColor] = useState<RgbColor>({r: control.parameters['r'], g: control.parameters['g'],  b: control.parameters['b']} || {r: 255, g: 0, b: 70})
    const [value, setValue] = useState<number>(control.current_value)
    const [rpc] = useRPC();

    const handleChange = useDebounce((color: RgbColor) => {
        setColor(color)
        rpc.updateRGBControlValue(control.id, value, color)
    }, 600)

    const onChange = useCallback(
        (value: number) => {
            setColor(color)
            setValue(value)
            rpc.updateRGBControlValue(control.id, value, color)
        },
        [rpc, color, control.id]
    )

    useEffect(() => {
        if (Number(control.parameters['r']) >= 155 && Number(control.parameters['g']) >= 155 && Number(control.parameters['b']) >= 155) {
            setColor(color);
        } else {
            setColor({
                r: control.parameters['r'],
                g: control.parameters['g'],
                b: control.parameters['b']
            })
        }
    }, [control.parameters])

    return (
        <Column min={6} max={12}>
            <ColorPicker
                color={color}
                height={"97.5px"}
                name={control.name}
                value={control.current_value}
                onChange={onChange}
                onChangeColor={handleChange}
                activeImage={controlType.image_set.active}
                passiveImage={controlType.image_set.passive}
            >
                {children}
            </ColorPicker>
        </Column>
    )
})
